export default __webpack_public_path__ + "static/media/pve3.856db756.jpg";